import React, { useState } from 'react';
export const WaterConsumptionTable: React.FC = () => {
  const [assumptions, setAssumptions] = useState({
    maneuverCompany: 23264,
    battalionCompany: 23264,
    universalUnitLevel: 23264,
    medicalOps: 96,
    showers: 6624,
    laundry: 832,
    medicalOpsAdvanced: 2816,
    mortuaryPotable: 704,
    mortuaryNonPotable: 0,
    engineer: 6336,
    aircraft: 416,
    epwOperations: 27840,
    forceProviderMilitary: 109312,
    forceProviderOther: 137312,
    washRack: 99000,
    washRackArmored: 110000,
    watercraft: 0
  });
  const handleChange = (key: keyof typeof assumptions, value: number) => {
    setAssumptions(prev => ({
      ...prev,
      [key]: value
    }));
  };
  const segmentTotal = assumptions.maneuverCompany + assumptions.battalionCompany + assumptions.universalUnitLevel + assumptions.medicalOps;
  const nonOrganicTotal = assumptions.showers + assumptions.laundry + assumptions.medicalOpsAdvanced + assumptions.mortuaryPotable + assumptions.mortuaryNonPotable + assumptions.engineer + assumptions.aircraft;
  const theaterTotal = assumptions.epwOperations + assumptions.forceProviderMilitary + assumptions.forceProviderOther + assumptions.washRack + assumptions.washRackArmored + assumptions.watercraft;
  const grandTotal = segmentTotal + nonOrganicTotal + theaterTotal;
  return <div className="overflow-x-auto bg-white border border-gray-200 rounded-md" data-id="element-771">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-772">
        <thead className="bg-gray-50" data-id="element-773">
          <tr data-id="element-774">
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-775">
              Segment of Force
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-776">
              Usage Rate
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-777">
              Factor
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-778">
              Unit Type
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-779">
              Total Gallons
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-780">
              Current Assumptions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-781">
          <tr className="bg-gray-100" data-id="element-782">
            <td colSpan={6} className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-783">
              Segment of Force
            </td>
          </tr>
          <tr data-id="element-784">
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-785">
              Maneuver Company
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-786">7.27</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-787">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-788">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-789">23,264</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-790">
              <input type="number" value={assumptions.maneuverCompany} onChange={e => handleChange('maneuverCompany', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-791" />
            </td>
          </tr>
          <tr data-id="element-792">
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-793">
              Battalion / Separate Company
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-794">7.27</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-795">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-796">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-797">23,264</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-798">
              <input type="number" value={assumptions.battalionCompany} onChange={e => handleChange('battalionCompany', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-799" />
            </td>
          </tr>
          <tr data-id="element-800">
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-801">
              Maneuver / Separate Brigade
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-802"></td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-803"></td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-804"></td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-805"></td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-806"></td>
          </tr>
          <tr data-id="element-807">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-808">
              Universal Unit Level
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-809">7.27</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-810">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-811">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-812">23,264</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-813">
              <input type="number" value={assumptions.universalUnitLevel} onChange={e => handleChange('universalUnitLevel', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-814" />
            </td>
          </tr>
          <tr data-id="element-815">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-816">
              Role I & II Medical Operations
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-817">0.03</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-818">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-819">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-820">96</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-821">
              <input type="number" value={assumptions.medicalOps} onChange={e => handleChange('medicalOps', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-822" />
            </td>
          </tr>
          <tr className="bg-gray-50" data-id="element-823">
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-824">
              Total
            </td>
            <td className="px-4 py-2" data-id="element-825"></td>
            <td className="px-4 py-2" data-id="element-826"></td>
            <td className="px-4 py-2" data-id="element-827"></td>
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-828">
              69,888
            </td>
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-829">
              {segmentTotal.toLocaleString()}
            </td>
          </tr>
          <tr className="bg-gray-100" data-id="element-830">
            <td colSpan={6} className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-831">
              Non-organic Functional Missions
            </td>
          </tr>
          <tr data-id="element-832">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-833">
              Central hygiene operations - showers
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-834">2.07</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-835">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-836">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-837">6,624</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-838">
              <input type="number" value={assumptions.showers} onChange={e => handleChange('showers', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-839" />
            </td>
          </tr>
          <tr data-id="element-840">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-841">
              Central hygiene operations - laundry
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-842">0.26</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-843">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-844">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-845">832</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-846">
              <input type="number" value={assumptions.laundry} onChange={e => handleChange('laundry', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-847" />
            </td>
          </tr>
          <tr data-id="element-848">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-849">
              Role III & IV Medical Operations
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-850">0.88</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-851">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-852">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-853">2,816</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-854">
              <input type="number" value={assumptions.medicalOpsAdvanced} onChange={e => handleChange('medicalOpsAdvanced', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-855" />
            </td>
          </tr>
          <tr data-id="element-856">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-857">
              Mortuary Affairs Operations - Potable
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-858">0.22</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-859">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-860">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-861">704</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-862">
              <input type="number" value={assumptions.mortuaryPotable} onChange={e => handleChange('mortuaryPotable', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-863" />
            </td>
          </tr>
          <tr data-id="element-864">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-865">
              Mortuary Affairs Operations - Non-Potable
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-866">NA</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-867">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-868">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-869">0</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-870">
              <input type="number" value={assumptions.mortuaryNonPotable} onChange={e => handleChange('mortuaryNonPotable', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-871" />
            </td>
          </tr>
          <tr data-id="element-872">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-873">
              Engineer Operations
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-874">1.98</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-875">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-876">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-877">6,336</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-878">
              <input type="number" value={assumptions.engineer} onChange={e => handleChange('engineer', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-879" />
            </td>
          </tr>
          <tr data-id="element-880">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-881">
              Aircraft Maintenance Operations
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-882">0.13</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-883">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-884">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-885">416</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-886">
              <input type="number" value={assumptions.aircraft} onChange={e => handleChange('aircraft', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-887" />
            </td>
          </tr>
          <tr className="bg-gray-50" data-id="element-888">
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-889">
              Total
            </td>
            <td className="px-4 py-2" data-id="element-890"></td>
            <td className="px-4 py-2" data-id="element-891"></td>
            <td className="px-4 py-2" data-id="element-892"></td>
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-893">
              17,728
            </td>
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-894">
              {nonOrganicTotal.toLocaleString()}
            </td>
          </tr>
          <tr className="bg-gray-100" data-id="element-895">
            <td colSpan={6} className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-896">
              Other Theater Functional Missions
            </td>
          </tr>
          <tr data-id="element-897">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-898">
              EPW, Civilian Internee Operations - Potable
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-899">8.7</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-900">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-901">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-902">27,840</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-903">
              <input type="number" value={assumptions.epwOperations} onChange={e => handleChange('epwOperations', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-904" />
            </td>
          </tr>
          <tr data-id="element-905">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-906">
              Force Provider Operations - Military Missions
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-907">34.16</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-908">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-909">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-910">109,312</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-911">
              <input type="number" value={assumptions.forceProviderMilitary} onChange={e => handleChange('forceProviderMilitary', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-912" />
            </td>
          </tr>
          <tr data-id="element-913">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-914">
              Force Provider Operations - Operations other than war
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-915">42.91</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-916">3200</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-917">
              gal / person / day
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-918">137,312</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-919">
              <input type="number" value={assumptions.forceProviderOther} onChange={e => handleChange('forceProviderOther', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-920" />
            </td>
          </tr>
          <tr data-id="element-921">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-922">
              Redeployment Vehicle Wash Rack Operations
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-923">9900</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-924">10</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-925">
              gal / company size unit
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-926">99,000</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-927">
              <input type="number" value={assumptions.washRack} onChange={e => handleChange('washRack', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-928" />
            </td>
          </tr>
          <tr data-id="element-929">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-930">
              Redeployment Vehicle Wash Rack Operations - armored / mechanized
              force
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-931">11000</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-932">10</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-933">
              gal / company size unit
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-934">110,000</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-935">
              <input type="number" value={assumptions.washRackArmored} onChange={e => handleChange('washRackArmored', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-936" />
            </td>
          </tr>
          <tr data-id="element-937">
            <td className="px-4 py-2 pl-8 text-sm text-gray-700" data-id="element-938">
              Watercraft Maintenance Operations
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-939">
              theater specific
            </td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-940"></td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-941"></td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-942">0</td>
            <td className="px-4 py-2 text-sm text-gray-700" data-id="element-943">
              <input type="number" value={assumptions.watercraft} onChange={e => handleChange('watercraft', Number(e.target.value))} className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-yellow-100 text-blue-600" data-id="element-944" />
            </td>
          </tr>
          <tr className="bg-gray-50" data-id="element-945">
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-946">
              Total
            </td>
            <td className="px-4 py-2" data-id="element-947"></td>
            <td className="px-4 py-2" data-id="element-948"></td>
            <td className="px-4 py-2" data-id="element-949"></td>
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-950">
              483,464
            </td>
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-951">
              {theaterTotal.toLocaleString()}
            </td>
          </tr>
          <tr className="bg-gray-100" data-id="element-952">
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-953">
              Total gallons
            </td>
            <td className="px-4 py-2" data-id="element-954"></td>
            <td className="px-4 py-2" data-id="element-955"></td>
            <td className="px-4 py-2" data-id="element-956"></td>
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-957">
              571,080
            </td>
            <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-958">
              {grandTotal.toLocaleString()}
            </td>
          </tr>
        </tbody>
      </table>
    </div>;
};